import { default as colors } from './colors';

export default { colors };
